/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicationTypeWithRelations } from '../../models/publication-type-with-relations';

export interface GetPublicationTypesList$Params {
}

export function getPublicationTypesList(http: HttpClient, rootUrl: string, params?: GetPublicationTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicationTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getPublicationTypesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PublicationTypeWithRelations>>;
    })
  );
}

getPublicationTypesList.PATH = '/publication-types';
